import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Tooltip,
  Typography,
} from 'antd';
import { ExclamationCircleFilled, WarningFilled } from '@ant-design/icons';
import colors from '../constants/Colors';
import BasicTimer from '../common/clock/BasicTimer';

const { Text } = Typography;

const HIGHLIGHT_MAP = {
  exceed: {
    backgroundColor: '#fff2f0',
    textColor: colors.ONTRACCR_RED,
    Icon: ExclamationCircleFilled,
    tooltipTitle: (title) => `${title} Threshold Exceeded. Either reset the current ${title.toLowerCase()} or update the threshold.`,
  },
  near: {
    backgroundColor: '#fff5cf',
    textColor: colors.YELLOW_500,
    Icon: WarningFilled,
    tooltipTitle: (title) => `${title} nearing threshold`,
  },
};

function EquipmentUsageTimer({
  label,
  value,
  highlightType,
  isLive,
  title,
  icon: Icon,
  onIconClick,
}) {
  const highlight = HIGHLIGHT_MAP[highlightType];
  const content = (
    <Card bordered={false} style={{ textAlign: 'center', backgroundColor: highlight?.backgroundColor ?? '#f9f9f9', cursor: highlight ? 'pointer' : 'default' }}>
      {highlight ? (
        <highlight.Icon
          style={{
            position: 'absolute',
            top: 8,
            left: 8,
            fontSize: 16,
            color: highlight?.textColor ?? colors.ONTRACCR_RED,
          }}
        />
      ) : null}
      {Icon && onIconClick ? (
        <Icon
          onClick={onIconClick}
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            fontSize: 16,
            color: colors.REDESIGN_BUTTON_UNSELECTED_TEXT,
            cursor: 'pointer',
          }}
        />
      ) : null}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Text style={{ fontSize: 14, color: '#888' }}>{`${label}: `}</Text>
        {isLive && typeof value === 'object' ? (
          <BasicTimer
            includeDays
            formattedDay={value}
            style={{
              fontSize: 18,
              fontFamily: 'raleway-semibold',
              color: colors.ONTRACCR_RED,
            }}
          />
        ) : (
          <Text style={{ fontSize: 18, fontFamily: 'raleway-semibold', color: colors.ONTRACCR_RED }}>
            {value}
          </Text>
        )}
      </div>
    </Card>
  );

  return highlight
    ? (
      <Tooltip
        title={highlight?.tooltipTitle(title)}
        color="white"
        overlayInnerStyle={{
          color: 'black',
        }}
      >{content}
      </Tooltip>
    )
    : content;
}

EquipmentUsageTimer.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  highlightType: PropTypes.oneOf(['exceed', 'near']),
  isLive: PropTypes.bool,
  title: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  onIconClick: PropTypes.func,
};

EquipmentUsageTimer.defaultProps = {
  highlightType: null,
  isLive: false,
  icon: null,
  onIconClick: null,
};

export default EquipmentUsageTimer;
